module.exports = __webpack_public_path__ + "img/1.94d86014.jpg";